import { Pipe, PipeTransform } from '@angular/core';
import { Image, ImageRole } from '@frontend/core';

/**
 * Picks the image for a layout slot from a model's flat `images` list by `role`,
 * e.g. `<img [src]="hub.images | imageForRole:'hero' | imageUrl:'w_1600'">`.
 *
 * Returns `null` when no image carries that role. Pass `fallbackToFirst = true` to
 * fall back to the first image in the list when the role is absent (mirrors the old
 * `media.find(...) ?? media[0]` behaviour for cover images).
 *
 * Pure (no `common` dependency); lives in `@frontend/shared` alongside `imageUrl`.
 */
@Pipe({
  name: 'imageForRole',
  standalone: true,
})
export class ImageForRolePipe implements PipeTransform {
  transform(
    images: Image[] | null | undefined,
    role: ImageRole,
    fallbackToFirst = false
  ): Image | null {
    if (!images?.length) {
      return null;
    }
    return images.find((i) => i.role === role) ?? (fallbackToFirst ? images[0] : null);
  }
}
